/** SSE progress: only real eval_count is token progress. Zero is still waiting. */

export function tokenProgressFromSse(
  data: { eval_count?: unknown; num_predict?: unknown } | null | undefined,
): { done: number; total: number } | null {
  if (!data || typeof data.eval_count !== 'number' || data.eval_count <= 0) return null
  const total = typeof data.num_predict === 'number' && data.num_predict > 0 ? data.num_predict : 1
  return { done: data.eval_count, total }
}
